import { type HrisEmployeeShiftStats, HrisRawSyncStatus, Position } from "../../../../../../utils/models";
import type { RoleStringRow } from "./useRoleStringRows";

/**
 * Number of employees in a role string actually syncing now: Synced AND linked to a still-active
 * nurse (DAT-154). Don't-Sync rows always count 0. A missing stats row means the employee isn't
 * nurse-linked (the stats endpoint only returns linked employees), so they aren't syncing to the
 * schedule and must NOT count. This keeps the count in lockstep with `buildActiveEmployees` so the
 * Don't-Sync dialog never claims syncing employees it can't deactivate.
 */
export const countSyncingEmployees = (row: RoleStringRow, statsByEmployeeId: Map<string, HrisEmployeeShiftStats>): number => {
	if (row.position === Position.DontSync) return 0;
	return row.rawEmployees.filter((e) => e.syncStatus === HrisRawSyncStatus.Synced && statsByEmployeeId.get(e.employeeId)?.active).length;
};
